import React from 'react'
import { Route } from '../../models/Route'
import { useNavigate } from 'react-router-dom';

interface Props{
    route:Route
}


const NavbarAdminItem = ({route}:Props) => {

    const navigate = useNavigate();

    const changePage = (page:string)=>{
        window.scrollTo(0, 0)
        navigate(page);
    }
    
  return (
    <div className={(window.location.pathname== route.path) ? "NavbarAdminItem-section-selected" :'NavbarAdminItem-section'} onClick={()=>{changePage(route.path);}}>{route.icon} {route.name}</div>
  )
}

export default NavbarAdminItem